import styled from "styled-components";

//main-screen

export const TableSorter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
`;

export const TableSorterItem = styled.div`
  display: flex;
  align-items: center;
  color: gray;
`;

export const TableSorterItemWrapper = styled.div`
  width: ${({ width }) => width};
  cursor: ${({ sortable }) => (sortable ? "pointer" : "auto")};
  display: flex;
  justify-content: start;
  align-items: center;
`;

//modal

export const ModalContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  border-bottom: gray 1px solid;
`;

export const ModalContentFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px;
  background: #fff;
  border-top: gray 1px solid;
`;

export const ModalContentTitle = styled.div`
  font-weight: 700;
  margin: 10px 0;
`;

export const ModalTitle = styled.div`
  font-weight: 700;
  font-size: 30px;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;
